import type { App } from 'vue'
import { vMaska } from 'maska/vue'

/** HH:MM — same pattern as legacy `$('.hora').mask('99:99')`. */
export const ADMIN_TIME_MASK = '##:##'

export function installMaska(app: App) {
  app.directive('maska', vMaska)
}
